/**
 * Service-worker cache policy contracts.
 * Keep public/sw.js behavior aligned with these helpers (source tests enforce it).
 */

/** Managed Cache Storage name prefixes owned by Wagamour SW. */
export const WAGAMOUR_CACHE_PREFIXES = ['wagamour-', 'wagamour-app-shell'] as const

/** Legacy unversioned app-shell cache that previously retained /_next/static. */
export const LEGACY_APP_SHELL_CACHE = 'wagamour-app-shell-v1'

export function isNextStaticAssetPath(pathname: string): boolean {
  return pathname.startsWith('/_next/static/')
}

export function isWagamourManagedCacheName(cacheName: string): boolean {
  if (cacheName === LEGACY_APP_SHELL_CACHE) return true
  return WAGAMOUR_CACHE_PREFIXES.some((prefix) => cacheName.startsWith(prefix))
}

/**
 * Caches to delete on SW activate.
 * Keeps only the current precache bucket; never preserves app-shell / Next chunks.
 */
export function shouldDeleteCacheOnActivate(
  cacheName: string,
  currentPrecacheName: string
): boolean {
  if (cacheName === currentPrecacheName) return false
  return isWagamourManagedCacheName(cacheName)
}
